<template>
  <router-view class="page-max-width footer-max-width" />
</template>

<script>
export default {};
</script>
